import { createContext, ReactNode, useContext, useMemo } from 'react';
import { useMediaQuery } from '@chakra-ui/react';
import { breakpoints } from '../theme';
import { BREAKPOINTS } from '../types/bitkit';

const minusOnePixel = (value: string) => {
  const valueInPixels = parseInt(value, 10) * 16;
  return `${valueInPixels - 1}px`;
};

const mediaQueries = [
  `(min-width: ${breakpoints[BREAKPOINTS.MOBILE]}) and (max-width: ${minusOnePixel(breakpoints[BREAKPOINTS.TABLET])})`,
  `(min-width: ${breakpoints[BREAKPOINTS.TABLET]}) and (max-width: ${minusOnePixel(breakpoints[BREAKPOINTS.DESKTOP])})`,
  `(min-width: ${breakpoints[BREAKPOINTS.DESKTOP]}) and (max-width: ${minusOnePixel(
    breakpoints[BREAKPOINTS.WIDEDESKTOP],
  )})`,
  `(min-width: ${breakpoints[BREAKPOINTS.WIDEDESKTOP]})`,
];

const ResponsiveContext = createContext({ isDesktop: false, isMobile: false, isTablet: false, isWideDesktop: false });
export const ResponsiveProvider = ({ children }: { children: ReactNode }) => {
  const [isMobile, isTablet, isDesktop, isWideDesktop] = useMediaQuery(mediaQueries);
  const context = useMemo(
    () => ({ isDesktop, isMobile, isTablet, isWideDesktop }),
    [isMobile, isTablet, isDesktop, isWideDesktop],
  );

  return <ResponsiveContext.Provider value={context}>{children}</ResponsiveContext.Provider>;
};

const useResponsive = () => {
  return useContext(ResponsiveContext);
};

export default useResponsive;
